<template>
  <div class="user-avatar" :style="{ height: width ?? defaultSideLengthPx }">
    <a-skeleton
      v-if="isLoading"
      active
      :avatar="{
        size: width ?? defaultSideLengthPx,
        shape: 'circle'
      }"
      :title="false"
      :paragraph="false"
    >
    </a-skeleton>

    <image-preview v-else :images="hasModal ? [imageSource] : []">
      <img
        alt="User Avatar"
        :src="imageSource"
        :style="{
          width: String(width ?? defaultSideLengthPx) + 'px',
          height: String(height ?? defaultSideLengthPx) + 'px',
          cursor: 'pointer'
        }"
    /></image-preview>
  </div>
</template>

<script>
import { Skeleton } from 'ant-design-vue'
import ImageViewer from '../entities/viewer/image-viewer.vue'

export default {
  components: {
    'a-skeleton': Skeleton,
    'image-preview': ImageViewer
  },
  props: {
    imagePath: {
      type: String,
      required: false
    },
    width: {
      type: Number,
      required: false
    },
    height: {
      type: Number,
      required: false
    },
    hasModal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultSideLengthPx: 40,
      imageSource: require('@/assets/img/avatar-placeholder.svg'),
      previousImagePath: null,
      isLoading: true,

      previewVisible: false
    }
  },
  computed: {
    isLinkAvailable() {
      return this.imagePath != null && this.imagePath.length > 0
    }
  },
  watch: {
    imagePath(newVal) {
      if (newVal !== this.previousImagePath) {
        this.tryToGetAvatar(newVal)
        this.previousImagePath = newVal
      }
    }
  },
  methods: {
    tryToGetAvatar(imagePath) {
      if (this.isLinkAvailable) {
        const img = new Image()
        img.onload = () => {
          this.imageSource = imagePath
          this.isLoading = false
        }
        img.onerror = () => {
          this.imageSource = require('@/assets/img/avatar-placeholder.svg')
          this.isLoading = false
        }
        img.src = imagePath.includes('base64') ? imagePath : imagePath + '?timestamp=' + new Date().getTime()
      } else {
        this.imageSource = require('@/assets/img/avatar-placeholder.svg')
        this.isLoading = false
      }
    }
  },
  mounted() {
    this.tryToGetAvatar(this.imagePath)
  }
}
</script>

<style>
.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.user-avatar img {
  border-radius: 8px;
  object-fit: cover;
}

.ant-skeleton-header .ant-skeleton-avatar-circle {
  border-radius: 8px !important;
}

.ant-skeleton-header {
  padding: 0 !important;
}
</style>
